#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"
#import "~/graphql/fragments/fields/links.graphql"

fragment globalDossierCardSection on globalDossierCard_Entry
{
    ... baseEntryFields
    featuredImage {
        ... image
    }
    links {
        ... links
    }
    shortDescription
}
